import { UploadContentTypeLPN } from "lib/util/constants";

/** Lock/unlock `?byLpn=` wins; create uses the Upload Content Type field. */
export function ResolveAsrsByLpn(opts: {
	byLpnFromUrl?: boolean;
	uploadContentType?: string | null;
}): boolean {
	if (opts.byLpnFromUrl !== undefined) {
		return opts.byLpnFromUrl;
	}
	return opts.uploadContentType === UploadContentTypeLPN;
}

/** ASRS create sets Upload Content Type; lock/unlock use the URL action. */
export function IsAsrsUpload(opts: {
	lockMode?: boolean;
	unlockMode?: boolean;
	uploadContentType?: string | null;
}): boolean {
	return Boolean(opts.lockMode || opts.unlockMode || opts.uploadContentType);
}

export function AsrsUploadSingleColumnRequired(byLpn: boolean): string {
	const item = byLpn ? "LPN" : "Serial Number";
	return `ASRS uploads must include ${item} in a single column only.`;
}

export function AsrsUploadColumnHint(byLpn: boolean): string {
	const item = byLpn ? "LPN" : "Serial Number";
	return `ASRS template: ${item} in a single column. Only .xlsx files accepted. First 10 rows previewed.`;
}

/**
 * ASRS files must have exactly one column. Call only when {@link IsAsrsUpload}
 * is true — do not infer ASRS from `partNumberRequired == null` (FlexNet sets
 * that while the PN gate is in flight).
 */
export function ValidateAsrsUploadColumnCount(
	colCount: number,
	asrsUpload: boolean,
	byLpn = false
): string | null {
	if (!asrsUpload) {
		return null;
	}
	if (colCount !== 1) {
		return AsrsUploadSingleColumnRequired(byLpn);
	}
	return null;
}
